/**
 * Shared Date Formatting Utility
 * Standardizes date displays across the application.
 */

// Format: MM/DD/YYYY
export const formatDateMDY = (dateLike) => {
    if (!dateLike) return "";
    const date = new Date(dateLike);
    if (isNaN(date.getTime())) return "";

    return new Intl.DateTimeFormat("en-US", {
        month: "2-digit",
        day: "2-digit",
        year: "numeric",
    }).format(date);
};

// Format: h:mm AM/PM
export const formatTime12h = (dateLike) => {
    if (!dateLike) return "";
    const date = new Date(dateLike);
    if (isNaN(date.getTime())) return "";

    return new Intl.DateTimeFormat("en-US", {
        hour: "numeric",
        minute: "2-digit",
        hour12: true,
    }).format(date);
};

// Format: MM/DD/YYYY h:mm AM/PM
export const formatDateTimeMDY12h = (dateLike) => {
    if (!dateLike) return "";
    const date = new Date(dateLike);
    if (isNaN(date.getTime())) return "";

    return `${formatDateMDY(date)} ${formatTime12h(date)}`;
};

// Convert Date/string to YYYY-MM-DDTHH:mm for input[type="datetime-local"]
export const toDatetimeLocalValue = (dateLike) => {
    if (!dateLike) return "";
    const date = new Date(dateLike);
    if (isNaN(date.getTime())) return "";

    const pad = (n) => n.toString().padStart(2, "0");
    const year = date.getFullYear();
    const month = pad(date.getMonth() + 1);
    const day = pad(date.getDate());
    const hours = pad(date.getHours());
    const minutes = pad(date.getMinutes());

    return `${year}-${month}-${day}T${hours}:${minutes}`;
};
